<script setup>
import { useField } from 'vee-validate'

const props = defineProps({
  size: {
    type: String,
    default: 'md',
    validator: value => ['sm', 'md', 'lg'].includes(value),
  },
  name: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: false,
  },
  successMessage: {
    type: String,
    default: '',
  },
  options: {
    // Você pode usar Options ou usar os slots!
    type: Array,
    required: false,
  },
  placeholder: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})

defineModel({ type: [String, Number] })

// Validate
const { value, errorMessage } = useField(() => props.name, undefined, {
  syncVModel: true,
})
</script>

<template>
  <div
    class="flex flex-col gap-1 border-none px-0.5 py-0"
    :class="{
      'text-neutral-40': disabled,
    }"
  >
    <label
      class="text-neutral-60"
      :class="{
        'text-base': size === 'lg',
        'text-sm': size === 'md',
        'text-xs': size === 'sm',
      }"
      :for="$attrs.id"
    >
      {{ label }}
    </label>
    <div class="flex flex-row items-center justify-end">
      <select
        v-bind="$attrs"
        class="placeholder:text-neutral-40 w-full rounded-lg py-0 pl-3"
        :class="{
          error: errorMessage,
          input: !errorMessage,
          'h-[38px]': size === 'md',
          'h-[44px]': size === 'lg',
          'h-[36px]': size === 'sm',
          'border-neutral-30': value === undefined || value === null || value === '',
          'border-neutral-40': value !== undefined && value !== null && value !== '',
        }"
        :id="$attrs.id"
        :disabled="disabled"
        v-model="value"
      >
        <option
          v-for="(item, index) in options"
          :value="item.value"
          :key="`${item.value}-selector`"
        >
          {{ item.label }}
        </option>
        <slot />
      </select>
    </div>
    <span class="text-error-60 text-xs" :id="`password-${$attrs.id}-errors`">
      {{ errorMessage }}
    </span>
  </div>
</template>

<style scoped>
@reference "@/assets/style/main.css";

.input {
  @apply disabled:bg-neutral-10 disabled:border-neutral-30 disabled:text-neutral-40 cursor-pointer;
}

.input:focus-visible {
  @apply border-[#4c94ff73];
  box-shadow: 0px 0px 0px 3px #4c94ff73;
}

.error {
  @apply bg-error-10 border-error-60 text-error-60;
  box-shadow: 0px 0px 0px 3px #f008024d;
}
</style>
